import React from "react";
import HeaderSectionReusableComponent from "../../component/ReusablaeComponent/HeaderSectionReusableComponent";
import PointsWithHeading from "../../component/ReusablaeComponent/PointsWithHeading";
import ECG from '../../../Assets/ESG.png'
import Environmental_Responsibility from '../../../Assets/Environmental Responsibility.png'
import Social_Responsibilityy from '../../../Assets/Social Responsibility.png'
import Governance_Frameworks from '../../../Assets/Governance Framework.png'
import Goals from '../../../Assets/ESG Goals & Metrics.png'
import Image_ContentReusable from "../../component/ReusablaeComponent/Image_ContentReusableComponent";

const ESG = () => {
  const environment_responsibility = [
    {
      strongText: "Sustainability Initiatives:",
      text: "Describe how your company minimizes its carbon footprint, reduces waste, and promotes renewable energy sources.",
    },
    {
      strongText: "Resource Efficiency:",
      text: "Highlight how your company is committed to efficient energy, water usage, and materials to ensure minimal environmental impact.",
    },
    {
      strongText: "Green Innovations:",
      text: "Discuss any innovative practices or technologies you employ to support sustainable development.",
    },
  ];
  const Social_Responsibility = [
    {
      strongText: "Diversity & Inclusion:",
      text: " Share how your company fosters a diverse workforce, promoting equality and inclusivity across all levels of the organization.",
    },
    {
      strongText: "Community Engagement:",
      text: " Explain your company’s involvement in local communities through charitable initiatives, volunteering, and social programs.",
    },
    {
      strongText: "Employee Well-being:",
      text: "Outline programs in place for health and safety, employee growth, and work-life balance.",
    },
    {
      strongText: "Customer and Stakeholder Trust:",
      text: "Show how your company builds trust through responsible business practices, ethical sourcing, and delivering quality products.",
    },
  ];
  const Governance_Framework = [
    {
      strongText: "Corporate Governance:",
      text: "Describe your company's board structure, leadership, and commitment to accountability and transparency.",
    },
    {
      strongText: "Ethical Practices:",
      text: ": Highlight the ethical policies and compliance mechanisms in place, such as anti-corruption, data privacy, and responsible sourcing.",
    },
    {
      strongText: "Risk Management:",
      text: " Discuss how your company manages risks related to ESG factors and ensures regulatory compliance across all operations.",
    },
  ];
  const Esg_Goals = [
    {
      strongText: "Sustainability Metrics:",
      text: "Provide measurable data on carbon emissions reduction, energy consumption, waste management, and water use.",
    },
    {
      strongText: "Social Impact Goals:",
      text: "Share specific objectives around employee diversity, community programs, and stakeholder satisfaction.",
    },
    {
      strongText: "Governance Standards:",
      text: "Define goals for enhancing corporate governance, ethical behavior, and transparency in decision-making.",
    },
  ];
  return (
    <div>
      <Image_ContentReusable
        heading="Empowering Businesses to Grow Responsibly with PTKCS"
        paragraph="In today’s world, success is no longer measured by profit alone. Investors, customers, and governments are placing increasing importance on Environmental, Social, and Governance (ESG) performance. At PTKCS Technologies, we help organizations embed ESG principles into their core business operations through intelligent digital solutions. Our services are designed not only to support regulatory compliance but to create real, measurable impact—enabling businesses to grow responsibly, reduce risk, and build long-term value for all stakeholders."
        imgsrc={ECG}
        reverse={false} 
        bgColor="#ffffff"
        headingColor="#eb7527ff"
        headingSize="2.5rem"
      />
      <Image_ContentReusable
        heading="Environmental Stewardship Through Smart Technology"
        paragraph="PTKCS helps businesses drive sustainability by digitizing and optimizing operations in ways that reduce environmental impact. We implement systems that allow enterprises to track energy consumption, monitor waste, analyze emissions, and report carbon footprints—all in real time. With integrated data and automation, companies can take actionable steps toward reducing resource usage, optimizing supply chains, and adopting green manufacturing practices.
        For example, in manufacturing or logistics, our solutions enable route optimization, energy-efficient scheduling, and predictive maintenance to extend the life of assets and reduce waste. In enterprise environments, we encourage paperless workflows, cloud migration, and the use of AI-driven analytics to support sustainable innovation. PTKCS empowers businesses to not only meet environmental compliance requirements but to lead as responsible, climate-conscious organizations."
        imgsrc={ECG}
        reverse={true} 
        bgColor="#ffffff"
        headingColor="#eb7527ff"
        headingSize="2.5rem"
      />
      <Image_ContentReusable
        heading="Social Impact with Inclusive, Ethical, and Transparent Solutions"
        paragraph="A strong social foundation is essential to long-term business sustainability. PTKCS enables organizations to prioritize people—employees, customers, suppliers, and communities—by building digital systems that support inclusivity, transparency, and fairness. Our human capital management (HCM) and workforce systems promote equitable hiring, diversity and inclusion tracking, health and safety compliance, and employee engagement programs.
                  We also help businesses manage ethical sourcing and responsible supply chains through tools that track vendor compliance, labor practices, and third-party risk. From CSR initiative management to community project monitoring, our systems offer businesses a way to measure and report social impact. With PTKCS, businesses can cultivate a culture of fairness and accountability, both internally and throughout their extended value chains."
        imgsrc={ECG}
        reverse={false} 
        bgColor="#ffffff"
        headingColor="#eb7527ff"
        headingSize="2.5rem"
      />
      <Image_ContentReusable
        heading="Governance Built on Integrity, Transparency, and Control"
        paragraph="Good governance begins with control, transparency, and accountability—core elements of the digital systems we deliver at PTKCS. We help enterprises put robust governance frameworks in place using advanced tools for audit trails, approval hierarchies, data security, and real-time reporting. These systems enable companies to reduce operational risk, ensure compliance with legal and industry standards, and create a trustworthy ecosystem for investors and regulators alike.
                  Our ERP and compliance solutions also integrate risk management, internal control mechanisms, and automated documentation processes that ensure decisions are traceable and defensible. Whether you're meeting local regulations or global governance benchmarks, PTKCS ensures you have the structure and systems to maintain ethical and legal accountability at every level of operation."
        imgsrc={ECG}
        reverse={true} 
        bgColor="#ffffff"
        headingColor="#eb7527ff"
        headingSize="2.5rem"
      />
      <Image_ContentReusable
        heading="ESG Analytics and Reporting for Measurable Impact"
        paragraph="Accountability in ESG depends on data. PTKCS delivers powerful analytics and dashboards that allow organizations to track and report ESG performance across key indicators—carbon emissions, social diversity, governance compliance, sustainability KPIs, and more. Our real-time reporting tools support internal reviews and stakeholder disclosures, while also ensuring readiness for audits and regulatory submissions.
                  With accurate ESG data at your fingertips, leadership teams can make informed decisions, allocate resources efficiently, and continuously improve their impact. Our reporting tools align with international ESG standards and frameworks such as GRI, SASB, and SDG alignment—so you can demonstrate your commitment with credibility and transparency."
        imgsrc={ECG}
        reverse={false} 
        bgColor="#ffffff"
        headingColor="#eb7527ff"
        headingSize="2.5rem"
      />
      <Image_ContentReusable
        heading="Why Choose PTKCS for Your ESG Journey"
        paragraph="PTKCS is more than a technology provider—we are a transformation partner that enables businesses to integrate ESG into the heart of their strategy. Our team combines domain expertise, technical capabilities, and industry insights to build customized ESG solutions that deliver long-term value. Whether you're taking your first step toward sustainability or enhancing an existing ESG framework, we’re here to help you align your operations with global expectations and future-proof your business."
        imgsrc={ECG}
        reverse={true} 
        bgColor="#ffffff"
        headingColor="#eb7527ff"
        headingSize="2.5rem"
      />

      {/* <PointsWithHeading
        bgColor="#fff"
        title="Environmental Responsibility"
        
        features={environment_responsibility}
        imageSrc={Environmental_Responsibility}
        altText="Environmental_Responsibility"
      />
      <PointsWithHeading
        reverse={false}
        title="Social Responsibility"
        features={Social_Responsibility}
        imageSrc={Social_Responsibilityy}
        altText="Social_Responsibilityy"
      />
      <PointsWithHeading
        bgColor="#fff"
        title="Governance Framework"
        
        features={Governance_Framework}
        imageSrc={Governance_Frameworks}
        altText="Governance_Frameworks"
      />
      <PointsWithHeading
      reverse={false}
        title="ESG Goals & Metrics"
        features={Esg_Goals}
        imageSrc={Goals}
        altText="Goals"
      /> */}
    </div>
  );
};

export default ESG;
